import Markdown from 'react-markdown';
import { Link } from 'react-router-dom';
import privacyText from '../content/datenschutz.md?raw';

// Der Text liegt in src/content/datenschutz.md; interne Links (beginnend mit
// "/") werden als Router-Links gerendert.
export function PrivacyPage() {
  return (
    <div className="card legal-content">
      <Markdown
        components={{
          a: ({ href, children }) =>
            href?.startsWith('/') ? (
              <Link to={href}>{children}</Link>
            ) : (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
        }}
      >
        {privacyText}
      </Markdown>
    </div>
  );
}
